import { render } from "./EnbFooter.vue?vue&type=template&id=12a261da&scoped=true"
import script from "./EnbFooter.vue?vue&type=script&lang=js"
export * from "./EnbFooter.vue?vue&type=script&lang=js"

import "./EnbFooter.vue?vue&type=style&index=0&id=12a261da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a261da"]])

export default __exports__